const DRAFT_KEY = "lpl-bug-widget:draft";
const REPORTER_KEY = "lpl-bug-widget:reporter";

export interface Draft {
  title: string;
  description: string;
}

export interface StoredReporter {
  name: string;
  email: string;
}

function read<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // stockage plein ou désactivé — non bloquant
  }
}

export const loadDraft = (): Draft | null => read<Draft>(DRAFT_KEY);
export const saveDraft = (draft: Draft): void => write(DRAFT_KEY, draft);
export function clearDraft(): void {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
}

export const loadReporter = (): StoredReporter | null => read<StoredReporter>(REPORTER_KEY);
export const saveReporter = (reporter: StoredReporter): void => write(REPORTER_KEY, reporter);

const SEEN_COMMENTS_KEY = "lpl-bug-widget:seen-comments";

/**
 * Suivi local (par navigateur) des commentaires consultés : bugId → date ISO
 * du dernier commentaire de l'équipe vu. Le client n'a pas de compte, la
 * pastille « nouveau commentaire » ne peut donc être que locale.
 */
export type SeenComments = Record<string, string>;

export const loadSeenComments = (): SeenComments =>
  read<SeenComments>(SEEN_COMMENTS_KEY) ?? {};

export function markCommentsSeen(bugId: string, lastTeamCommentAt: string): SeenComments {
  const seen = { ...loadSeenComments(), [bugId]: lastTeamCommentAt };
  write(SEEN_COMMENTS_KEY, seen);
  return seen;
}
